import { IS_UPCOMING_SESSIONS_ENABLED } from '@/features/flags';
import { useIntegrationEhrInfo } from '@/hooks/integrations/useIntegrationEhrInfo';
import { isLetterSenderEHRProvider } from '@heidi/integrations/letters';

export const useShouldUseUpcomingSessions = () => {
  const { integrationEhrProvider } = useIntegrationEhrInfo();

  return (
    IS_UPCOMING_SESSIONS_ENABLED() &&
    (!integrationEhrProvider || isLetterSenderEHRProvider(integrationEhrProvider))
  );
};
